module.exports = __webpack_public_path__ + "static/img/2.b31c9a27.png";